
// console.log
const log = (item) => {
    // return
    console.log('\x1B[36m%s\x1B[0m', '-----------------------------------------------------------------------------')
    console.log(item)
}

export default log